export const redoInitialState = {
  pendingRedos: [],
};

const redoReducer = (state = redoInitialState, action) => {
  switch (action.type) {
    case 'CLEAR':
      return { ...redoInitialState };
    case 'SET_PENDING_REDOS':
      return {
        ...state,
        pendingRedos: action.payload,
      };
    case 'REMOVE_PENDING_REDO':
      return {
        ...state,
        pendingRedos: state.pendingRedos.filter(
          (redo) => redo.media_key !== action.payload
        ),
      };
    default:
      return state;
  }
};

export default redoReducer;
